import { z } from 'zod';
import { isoDateTimeSchema, uuidSchema } from './common.js';
/**
 * Shared wire schemas for player-side resources surfaced to the admin
 * console. Currently scoped to the player-offline-incidents data layer
 * shipped with Wave 2.44 BE-2 (TASK-286) — extend in-place when the
 * admin "Active offline players" endpoint lands.
 */
/**
 * `customers.player_offline_incidents` row — F-23 dedup state for the
 * player-offline alert pipeline.
 *
 *   - `resolved_at = null` ⇒ incident is active. The DB partial unique
 *     `(player_id) WHERE resolved_at IS NULL` enforces "one active row
 *     per player".
 *   - `last_alert_sent_at = null` ⇒ alert never dispatched yet; the cron
 *     picks the row on its next pass.
 *   - `alert_count` increments on every dispatch — kept for the admin
 *     timeline ("3 alerts over 12h outage") and to bound retries if a
 *     cap is added later.
 */
export const playerOfflineIncidentSchema = z
    .object({
    id: uuidSchema,
    player_id: uuidSchema,
    account_id: uuidSchema,
    venue_id: uuidSchema,
    started_at: isoDateTimeSchema,
    resolved_at: isoDateTimeSchema.nullable(),
    last_alert_sent_at: isoDateTimeSchema.nullable(),
    alert_count: z.number().int().min(0),
    created_at: isoDateTimeSchema,
    updated_at: isoDateTimeSchema,
})
    .strict();
//# sourceMappingURL=player.js.map